/**
 * VISTOERA_SAAS_I18N_FOUNDATION V1 — Ant Design + dayjs locale binding
 * (spec §12/§13). One lookup table, so `Pagination`/`DatePicker`/`Empty`/
 * `Upload`/`Table`/`Modal` built-in copy and dayjs's own locale (weekday
 * names, relative-time strings) can never drift apart the way spec §13
 * explicitly forbids ("AntD locale = en-US, dayjs locale = zh-CN 这种混合
 * 状态").
 */
import type { Locale as AntdLocale } from 'antd/es/locale'
import zhCN from 'antd/locale/zh_CN'
import enUS from 'antd/locale/en_US'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import type { UiLocale } from './types'

const ANTD_LOCALE_MAP: Record<UiLocale, AntdLocale> = {
  'zh-CN': zhCN,
  'en-US': enUS,
}

/** dayjs's own locale identifiers — deliberately NOT the same string as
 * `UiLocale` ('zh-CN' -> 'zh-cn', 'en-US' -> 'en') since dayjs's locale
 * registry is lowercase/hyphenated and doesn't mirror BCP-47 casing. */
const DAYJS_LOCALE_MAP: Record<UiLocale, string> = {
  'zh-CN': 'zh-cn',
  'en-US': 'en',
}

export function getAntdLocale(locale: UiLocale): AntdLocale {
  return ANTD_LOCALE_MAP[locale]
}

/** Sets the dayjs GLOBAL default locale. Safe to call on every UI locale
 * change — this only affects display formatting (weekday/month names,
 * `dayjs().fromNow()` wording), never the underlying stored instant/
 * timestamp, and never anything sent to the API (spec §10 "API / DB
 * timestamp 继续使用 canonical machine format"). */
export function syncDayjsLocale(locale: UiLocale): void {
  dayjs.locale(DAYJS_LOCALE_MAP[locale])
}
